import React from 'react'
import Tag from './Tag'

const Link = props =>
  <Tag _name="link" {...props} />

export default Link
